import { Check } from 'lucide-react';
import { motion } from 'motion/react';
import { theme } from '../../styles/theme';
import { useIsMobile } from '../../hooks/useIsMobile';
import type { AgentEvent } from '../../types';
import { getToolStates, STATUS_BAR_TOOLS } from './toolUtils';

export function ToolStatusBar({ events }: { events: AgentEvent[] }) {
  const mobile = useIsMobile();
  const toolStates = getToolStates(events);
  const iconSize = mobile ? 32 : 44;

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', gap: mobile ? theme.spacing.sm : theme.spacing.xl,
      padding: `${theme.spacing.md} ${mobile ? theme.spacing.sm : theme.spacing['2xl']}`,
      background: 'white', borderRadius: theme.borderRadius['2xl'],
      border: `1px solid ${theme.colors.borderLight}`,
      boxShadow: theme.shadows.card,
      width: '100%', maxWidth: '40rem',
      overflow: 'hidden', flexShrink: 0,
    }}>
      {STATUS_BAR_TOOLS.map(({ key, label, Icon }) => {
        const state = toolStates[key];
        return (
          <div key={key} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: theme.spacing.xs, minWidth: 0, flex: '1 1 0' }}>
            <div style={{ width: iconSize, height: iconSize, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <motion.div
                animate={state === 'active' ? {
                  boxShadow: [
                    `0 0 0 0 ${theme.colors.teal}00`,
                    `0 0 12px 4px ${theme.colors.teal}40`,
                    `0 0 0 0 ${theme.colors.teal}00`,
                  ],
                } : undefined}
                transition={state === 'active' ? { duration: 1.5, repeat: Infinity, ease: 'easeInOut' } : undefined}
                style={{
                  width: iconSize, height: iconSize,
                  borderRadius: theme.borderRadius.lg,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  transition: `all ${theme.transitions.normal}`,
                  background: state === 'completed' ? theme.colors.teal : 'transparent',
                  color:
                    state === 'idle'      ? theme.colors.muted :
                    state === 'active'    ? theme.colors.teal :
                                            'white',
                  transform: state === 'active' ? 'scale(1.15)' : 'scale(1)',
                }}
              >
                {state === 'completed' ? <Check size={mobile ? 14 : 18} /> : <Icon size={mobile ? 14 : 18} />}
              </motion.div>
            </div>
            <span style={{
              fontSize: mobile ? '0.5rem' : '0.6rem', fontWeight: theme.fontWeight.bold,
              textTransform: 'uppercase', letterSpacing: '0.2em',
              color: state === 'idle' ? theme.colors.muted : theme.colors.teal,
            }}>
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
